import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Column } from 'mage-components';
import { selectors as i18nSelectors } from 'mage-i18n';
import { BoxSelectorDetailed, Frame, SpacerVertical, Typography } from '@klarna/bubble-ui';
const componentPropTypes = {
    currencyFormatterFactory: PropTypes.func.isRequired,
    currentConfig: PropTypes.shape({
        VOLUME_SEPARATION: PropTypes.shape({
            AO: PropTypes.arrayOf(PropTypes.string).isRequired,
            large: PropTypes.number.isRequired,
            skipMedium: PropTypes.bool.isRequired,
            small: PropTypes.number.isRequired,
            medium: PropTypes.number,
        }).isRequired,
    }).isRequired,
    currentCountry: PropTypes.shape({
        currency: PropTypes.string.isRequired,
    }).isRequired,
};
const VolumeSeparationComponent = ({ currencyFormatterFactory, currentCountry, currentConfig, }) => {
    const currencyFormatter = currencyFormatterFactory(currentCountry.currency || 'EUR', true);
    return (React.createElement(Frame, null,
        React.createElement(Row, null,
            React.createElement(Column, { columns: { mobile: 12 } },
                React.createElement(Typography, { textToken: "text-style/headings/titles/bold/tertiary" }, "Volume segmentation"))),
        React.createElement(Row, null,
            React.createElement(Column, { columns: { mobile: 12 } },
                React.createElement(SpacerVertical, { spaceToken: "space.200" }),
                React.createElement(BoxSelectorDetailed, { options: [
                        {
                            content: `Below ${currencyFormatter.format(currentConfig.VOLUME_SEPARATION[currentConfig.VOLUME_SEPARATION.skipMedium ? 'large' : 'medium'])}`,
                            description: 'Small volume tier',
                            value: 'small',
                            contentRight: currentConfig.VOLUME_SEPARATION.AO.includes('SMALL_BUSINESS')
                                ? 'Automatic Onboarding'
                                : 'Sales',
                        },
                        ...(currentConfig.VOLUME_SEPARATION.skipMedium
                            ? []
                            : [
                                {
                                    content: `Below ${currencyFormatter.format(currentConfig.VOLUME_SEPARATION.large)}`,
                                    description: 'Small volume tier',
                                    value: 'medium',
                                    contentRight: currentConfig.VOLUME_SEPARATION.AO.includes('MEDIUM_BUSINESS')
                                        ? 'Automatic Onboarding'
                                        : 'Sales',
                                },
                            ]),
                        {
                            content: `Above ${currencyFormatter.format(currentConfig.VOLUME_SEPARATION.large)}`,
                            description: 'Enterprise volume tier',
                            value: 'large',
                            contentRight: currentConfig.VOLUME_SEPARATION.AO.includes('LARGE_BUSINESS')
                                ? 'Automatic Onboarding'
                                : 'Sales',
                        },
                    ], layout: "horizontal" })))));
};
VolumeSeparationComponent.propTypes = componentPropTypes;
export const VolumeSeparation = connect(state => ({
    currencyFormatterFactory: i18nSelectors.formatters.currency(state),
}))(VolumeSeparationComponent);
